
export const getToken = async () => {
    const apiKey = '0a032477a6f2cc1cd91960d1e554561151f0458ca433e98b848d';
    try {
        const response = await fetch('https://app.nftforest.ge/cashola/token.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiKey}`,
                'User-Agent': 'EricLystra',
                'x-auth': 'NFTForest',
                'x-api-key': apiKey,
            },
            mode: 'cors',
            credentials: 'include'
        });
        const res = await response.json()
        return res.access_token

    } catch (error) {
        console.error('Error during login:', error);
    }
}

/**
 * Create order in database before sending to BoG
 * @param {Array} items - Array of tree IDs
 * @returns {Promise<Object>} Order creation result with external_order_id
 */
export const createOrder = async (items = []) => {
    try {
        const totalCost = items.length * 150;
        const externalOrderId = Date.now().toString();
        
        const response = await fetch('https://app.nftforest.ge/cashola/callback.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({
                action: 'create_order',
                external_order_id: externalOrderId,
                trees: items,
                total_cost: totalCost
            })
        });
        
        if (!response.ok) {
            throw new Error('Failed to create order');
        }
        
        const result = await response.json();
        
        if (result.success) {
            console.log('Order created successfully:', result);
            return result;
        } else {
            throw new Error(result.error || 'Failed to create order');
        }
    } catch (error) {
        console.error('Error creating order:', error);
        throw error;
    }
}

export const makeOreder = async (token, items = [], orderReference = null) => {
    try {
        let externalOrderId = orderReference;
        
        // If no orderReference provided, create order first
        if (!externalOrderId) {
            console.log('Creating order before sending to BoG...');
            const orderResult = await createOrder(items);
            externalOrderId = orderResult.external_order_id;
            console.log('Order created with external_order_id:', externalOrderId);
        }
        
        const response = await fetch('https://api.bog.ge/payments/v1/ecommerce/orders', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': 'ka',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                "callback_url": "https://app.nftforest.ge/incoming/web/cashola/callback.php",
                "external_order_id": externalOrderId,
                "purchase_units": {
                    "currency": "GEL",
                    "total_amount": items.length * 150,
                    "basket": items.map(item => ({
                        "quantity": 1,
                        "unit_price": 150,
                        "product_id": item
                    }))
                },
                "redirect_urls": {
                    "fail": "https://app.nftforest.ge/fail",
                    "success": `https://app.nftforest.ge/return?order_reference=${externalOrderId}`
                }
            })
        })
        const res = await response.json()
        return res
    } catch (error) {
        console.error('Error during order creation:', error);
        throw error;
    }
}

/**
 * Complete BoG payment order - updates trees to sponsored status
 * @param {number|null} orderId - Order ID from database
 * @param {string|null} referenceId - Order reference ID (external_order_id)
 * @returns {Promise<Object>} Success result
 */
export const completeBoGOrder = async (orderId = null, referenceId = null) => {
    try {
        const url = new URL('https://app.nftforest.ge/incoming/web/cashola/bog_success.php');
        if (orderId) {
            url.searchParams.append('order_id', orderId);
        }
        if (referenceId) {
            url.searchParams.append('reference_id', referenceId);
        }
        
        if (!orderId && !referenceId) {
            throw new Error('Either order_id or reference_id must be provided');
        }
        
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        });
        
        const result = await response.json();
        
        if (result.success) {
            console.log('Payment completed successfully, trees updated');
            return result;
        } else {
            console.error('Payment completion error:', result.error);
            throw new Error(result.error || 'Payment completion failed');
        }
    } catch (error) {
        console.error('Error completing BoG order:', error);
        throw error;
    }
}

/**
 * Check BoG order status from API
 * @param {string} orderId - BoG order ID
 * @param {string} token - BoG access token
 * @returns {Promise<Object>} Order status
 */
export const checkBoGOrderStatus = async (orderId, token) => {
    try {
        const response = await fetch(`https://api.bog.ge/payments/v1/ecommerce/orders/${orderId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        
        const order = await response.json();
        
        // If payment is completed, call success handler
        if (order.status === 'COMPLETED' || order.status === 'SUCCESS' || order.status === 'PAID') {
            await completeBoGOrder(null, order.external_order_id);
        }
        
        return order;
    } catch (error) {
        console.error('Error checking order status:', error);
        throw error;
    }
}